/**
 * How long a single recording may run.
 *
 * A cap exists because nothing else in the pipeline imposes one, and every stage downstream pays
 * for its absence: Mux stores and bills the whole of it, a browser holds the growing blob in
 * memory until the upload starts, and a recording that removes a stretch from its middle has to
 * be handed to a renderer whose cost grows with the source. A tutorial that genuinely needs more
 * than half an hour is a tutorial that should have been two.
 *
 * The limit counts **active** recording time, which is what a pause removes and therefore what
 * the finished video's duration will be — not the wall clock the author spent at it.
 */
export const MAX_RECORDING_MINUTES = 30;

/** {@link MAX_RECORDING_MINUTES} in milliseconds, which is what the recorder counts in. */
export const MAX_RECORDING_MS = MAX_RECORDING_MINUTES * 60 * 1000;

/**
 * How much recording time is left, in milliseconds.
 *
 * @param elapsedMs - Active recording time so far.
 * @returns The remaining time, never negative.
 */
export function remainingRecordingMs(elapsedMs: number) {
	return Math.max(0, MAX_RECORDING_MS - elapsedMs);
}
